import { render, staticRenderFns } from "./TimeSyncStreamax.vue?vue&type=template&id=d1a780de&scoped=true&"
import script from "./TimeSyncStreamax.vue?vue&type=script&lang=ts&"
export * from "./TimeSyncStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./TimeSyncStreamax.vue?vue&type=style&index=0&id=d1a780de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a780de",
  null
  
)

export default component.exports